import uniqBy from 'lodash/uniqBy';
import { useMemo } from 'react';

export default function useExtraOptions({
  options: inputOptions, extraOptions, ...props
}) {
  const options = useMemo(
    () => {
      if (!Array.isArray(extraOptions)) {
        return inputOptions;
      }
      if (Array.isArray(inputOptions)) {
        return uniqBy([...extraOptions, ...inputOptions], 'value');
      }
      return inputOptions;
    },
    [inputOptions, extraOptions],
  );
  return { options, ...props };
}
